import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@shared/shared.module';
import { ReportViewComponent } from '@app/main/report-view/report-view.component';
import { ReportViewPlaceholderComponent } from '@app/main/report-view/components/report-view-placeholder/report-view-placeholder.component';
import { ReportViewRoutingModule } from './report-view-routing.module';
import { ReportViewViewComponent } from './components/report-view-view/report-view-view.component';
import { ReportViewNoEntryComponent } from './components/report-view-no-entry/report-view-no-entry.component';

@NgModule({
    declarations: [
        ReportViewComponent,
        ReportViewViewComponent,
        ReportViewPlaceholderComponent,
        ReportViewNoEntryComponent
    ],
    imports: [CommonModule, SharedModule, ReportViewRoutingModule]
})
export class ReportViewModule {}
